import React from "react";
import { signOut } from "firebase/auth";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStates } from "../utils/globalStates";
import { firebaseAuth } from "../firebase/auth";
import { DEFAULT_DASHBOARD_PATH, isDashboardPath } from "../../views/dashboard/dashboardRoutes";
import "./Header.css";

type MenuItem = { label: string; path: string };
const workspaceLinks: MenuItem[] = [
  { label: "Dashboard", path: DEFAULT_DASHBOARD_PATH },
  { label: "Gårdar", path: "/farms" },
  { label: "Odlingar", path: "/grows" },
  { label: "Enheter", path: "/devices" },
  { label: "Plantor", path: "/plants" },
  { label: "Produkter", path: "/products" },
  { label: "Batcher", path: "/batches" },
  { label: "Etiketter", path: "/labels" },
];
const ownerLinks: MenuItem[] = [
  { label: "Plantvärden", path: "/owner/plant/enums" },
  { label: "Enhetsvärden", path: "/owner/device/enums" },
  { label: "Registrera enhet", path: "/owner/device/register" },
  { label: "Enhetslista", path: "/owner/device/list" },
];

export default function MenuDrawer({ setIsDrawerOpen }: { setIsDrawerOpen: (open: boolean) => void }) {
  const role = useAuthStates((state) => state.role);
  const location = useLocation();
  const navigate = useNavigate();
  const goTo = (path: string) => { setIsDrawerOpen(false); navigate(path); };
  const renderLinks = (links: MenuItem[]) => links.map(({ label, path }) => {
    const active = label === "Dashboard" ? isDashboardPath(location.pathname) : location.pathname === path;
    return <button className={`MenuDrawerLink${active ? " isActive" : ""}`} type="button" key={path} onClick={() => goTo(path)} aria-current={active ? "page" : undefined}><span>{label}</span><span aria-hidden="true">›</span></button>;
  });

  return <nav className="MenuDrawer" aria-label="Huvudnavigering">
    <div className="MenuDrawerIntro"><span className="MenuDrawerEyebrow">VERT.farm</span><strong>Välj arbetsyta</strong><p>Snabb åtkomst till appens delar.</p></div>
    <div className="MenuDrawerScroll">
      <section className="MenuDrawerSection" aria-label="Arbetsytor"><h2>Arbetsytor</h2>{renderLinks(workspaceLinks)}</section>
      {(role === "admin" || role === "owner") && <section className="MenuDrawerSection" aria-label="Administration"><h2>Administration</h2>{renderLinks([{ label: "Oskarström", path: "/sweden" }])}</section>}
      {role === "owner" && <section className="MenuDrawerSection" aria-label="Ägarverktyg"><h2>Ägarverktyg</h2>{renderLinks(ownerLinks)}</section>}
    </div>
    <button className="MenuDrawerSignout" type="button" onClick={() => { setIsDrawerOpen(false); signOut(firebaseAuth); }}><LogoutOutlinedIcon fontSize="small" /> Logga ut</button>
  </nav>;
}
